import { ParticlesStateModel } from './particles.state.model';
import { ParticleSystem, ParticleConstraint, ParticleCreator, ParticleUpdater } from '../../models/particles/particle-system-types';
import { TweenParticleLookupModel } from 'src/app/story/models/tween-particle-lookup.model';
import { Patch } from 'src/vendor/immer-6.0.9/compat/pre-3.7/dist/immer';

export namespace ParticleActions {

  export class SetParticleState {
    static readonly type = '[Engine Particles] Set Particle State';
    constructor (
      public particleSystems: ParticleSystem[],
      public assignedParticles: ParticlesStateModel['assignedParticles'], 
      public tweenParticleLookup: TweenParticleLookupModel) {}
  }

  export class NewParticleSystem {
    static readonly type = '[Engine Particles] New Particle System';
    constructor (public particleSystem: ParticleSystem, public chapterId: string) {}
  }

  export class DuplicateParticleSystem {
    static readonly type = '[Engine Particles] Duplicate Particle System';
    constructor (public id: string, public targetChapterId: string) {}
  }

  export class DuplicateParticleSystemSuccess {
    static readonly type = '[Engine Particles] Duplicate Particle System Success';
    constructor (public id: string, public targetChapterId: string) {}
  }

  export class UpdateParticleSystem {
    static readonly type = '[Engine Particles] Update Particle System';
    constructor (public id: string, public particleSystem: ParticleSystem) {}
  } 

  export class SetParticleSystemId {
    static readonly type = '[Engine Particles] Set Particle System Id';
    constructor (public oldId: string, public newId: string) {}
  } 
  
  export class SetParticleSystemsVisible {
    static readonly type = '[Engine Particles] Set Particle Systems Visible';
    constructor (public visible: boolean, public chapterId: string) {}
  }

  export class SetParticleSystemVisible {
    static readonly type = '[Engine Particles] Set Particle System Visible';
    constructor (public id: string, public visible: boolean, public chapterId: string) {}
  }

  export class AssignParticle {
    static readonly type = '[Engine Particles] Assign Particle';
    constructor (public id: string, public chapterId: string) {} 
  }

  export class UnassignParticle {
    static readonly type = '[Engine Particles] Unassign Particle';
    constructor (public id: string, public chapterId: string) {} 
  }

  export class DeleteParticleSystem {
    static readonly type = '[Engine Partiles] Delete Particle System';
    constructor (public id: string) {}
  }

  export class SelectParticleSystem {
    static readonly type = '[Engine Partiles] Select Particle System';
    constructor (public id: string) {}
  }

  export class SelectParticleConstraint {
    static readonly type = '[Engine Partiles] Select Particle Constraint';
    constructor(public index: number) { }
  }

  export class SelectParticleCreator {
    static readonly type = '[Engine Partiles] Select Particle Creator';
    constructor(public index: number) { }
  }

  export class SelectParticleUpdater {
    static readonly type = '[Engine Partiles] Select Particle Updater';
    constructor(public index: number) { }
  }

  export class UpdateTweenParticleLookupChapters {
    static readonly type = '[Engine Particles] Update Lookup Chapters';
    constructor(public chapterMap: Record<string, string>) { }
  }
  export class SetLookupForChapter {
    static readonly type = '[Engine Particles] Set Lookup for chapter';
    constructor(public chapterId: string, public lookup: Record<string, string>) { }
  }

  export class DeleteChapterLookup {
    static readonly type = '[Engine Particles] Delete chapter lookup';
    constructor(public chapterId: string) { }
  }

  export class ApplyPatch {
    static readonly type = '[Engine Particles] Apply Patch';
    constructor(public patches: Patch[]) {}
  }
}
